import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CourseDetails from "../../components/CourseDetails/CourseDetails";
import Footer from "../../components/Footer/Footer";
import PageTop from "../../components/PageTop/PageTop";
import AppUrl from "../../RestApi/AppUrl";
import RestClient from "../../RestApi/RestClient";
import MainNav from "../../shared/MainNav/MainNav";

export default function CourseDetailPage() {
  const { id, name } = useParams();

  const [data, setData] = useState({
    name: "",
    image: "",
    shortDes: "",
    videoUrl: "",
    totalEnroll: "",
    totalDuration: "",
    totalLecture: "",
  });

  useEffect(() => {
    RestClient.GetRequest(AppUrl.CourseDetails + id).then((result) =>
      setData({
        name: result[0]["short_title"],
        image: result[0]["course_image"],
        shortDes: result[0]["short_description"],
        videoUrl: result[0]["video_url"],
        totalDuration: result[0]["total_duration"],
        totalEnroll: result[0]["total_enrollment"],
        totalLecture: result[0]["total_lecture"],
      })
    );
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="Course Details" />
      <PageTop pageTitle={name} />
      <CourseDetails data={data} />
      <Footer />
    </>
  );
}
